import { all } from "redux-saga/effects";

//public
import accountSaga from "./auth/register/saga";
import LayoutSaga from "./layout/saga";

export default function* rootSaga() {
  yield all([
    //public
    accountSaga(),
    LayoutSaga(),
  ]);
}
